import { createPagination } from './js/pagination';

createPagination(20000);
